import React from 'react';
import "./Border.module.css";

const Border = () => {
  return (
    <div className='border border-boderBg'></div>
  )
}

export default Border